(() => {
    'use strict'
    // todo: remove old select managment when replacing it with the new select
    // determines select filter type 1 => old select, 2 => new select
    const filterType = document.getElementById('brand_id') === null ? 2 : 1;
    const brandSelector = filterType === 1 ? document.getElementById('brand_id') : $('#brand');
    const selectsForBrand = document.querySelectorAll('option[data-brand-id]');

    if (brandSelector === null || selectsForBrand.length === 0) {
        return;
    }

    if (filterType === 1) {
        brandSelector.addEventListener('change', () => {
            displayOnlyBrandOptions(brandSelector.value);
        });
    } else {
        brandSelector.select2({
            theme: 'bootstrap4'
        }).on('change', function () {
            displayOnlyBrandOptions(brandSelector.val());
        });
    }
    const displayOnlyBrandOptions = (brandId) => {
        if(brandId === '' || brandId == null) {
            selectsForBrand.forEach(node => {
                node.style.display = 'block';
            });

            return;
        }

        const lookupBrandId = `[data-brand-id="${brandId}"]`;
        const optionsToShow = document.querySelectorAll(`option[data-brand-id]:is(${lookupBrandId})`);
        const optionsToHide = document.querySelectorAll(`option[data-brand-id]:not(${lookupBrandId})`);

        optionsToHide.forEach(node => {
            if(filterType === 1) {
                node.style.display = 'none';
            } else {
                $(node).prop('disabled', true);
            }
        });

        optionsToShow.forEach(node => {
            if(filterType === 1) {
                node.style.display = 'block';
            } else {
                $(node).prop('disabled', false);
            }
        });
    }

    displayOnlyBrandOptions(filterType === 1 ? brandSelector.value : brandSelector.val());

})();
